export const FETCH_MANDANT_DATA = "FETCH_MANDANT_DATA";
export const FETCH_MANDANT_LOGO = "FETCH_MANDANT_LOGO";
export const NEW_MANDANT_DATA = "NEW_MANDANT_DATA";
export const FETCH_MANDANT_ORDER_LIMIT = "FETCH_MANDANT_ORDER_LIMIT";
